import React from 'react'
import Select from './Select'

const Home = () => {
  return (
    <div className='px-2'>
      <Select/>
    </div>
  )
}

export default Home